import apiBase from './apiBase';

export default class mypageApi {
  static async absentWithNotice(id, absence_reason_id, absence_reason_comment) {
    return await apiBase.patch(`/api/mypage_api/school_attendance/${id}/absent_with_notice`, {
      absence_reason_id,
      absence_reason_comment,
    });
  }

  static async cancelAbsentWithNotice(id) {
    return await apiBase.patch(`/api/mypage_api/school_attendance/${id}/cancel_absent_with_notice`);
  }

  static async schoolXAbsentWithNotice(id, absence_reason_id, absence_reason_comment) {
    return await apiBase.patch(`/api/mypage_api/school_x_attendance/${id}/absent_with_notice`, {
      absence_reason_id,
      absence_reason_comment,
    });
  }

  static async schoolXCancelAbsentWithNotice(id) {
    return await apiBase.patch(`/api/mypage_api/school_x_attendance/${id}/cancel_absent_with_notice`);
  }

  static async addSchoolExtraClass(id, school_extra_class_id) {
    return await apiBase.patch(`/api/mypage_api/school_attendance/${id}/school_extra_class`, {
      school_extra_class_id,
    });
  }

  static async cancelExtraClass(id) {
    return await apiBase.patch(`/api/mypage_api/school_attendance/${id}/cancel_school_extra_class`);
  }

  static async setDefaultCard(id) {
    return await apiBase.patch('/api/mypage_api/credit_cards/set_default', {
      id,
    });
  }

  static async editCardExpirationDate(id, exp_month, exp_year) {
    return await apiBase.patch('/api/mypage_api/credit_cards/', {
      id,
      exp_month,
      exp_year,
    });
  }

  static async deleteCard(id) {
    return await apiBase.delete('/api/mypage_api/credit_cards/', {
      id,
    });
  }
}
